import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AccountingCode\CreateAccountingCodeController::__invoke
* @see app/Http/Controllers/AccountingCode/CreateAccountingCodeController.php
* @route '/api/accounting-code'
*/
const CreateAccountingCodeController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateAccountingCodeController.url(options),
    method: 'post',
})

CreateAccountingCodeController.definition = {
    methods: ["post"],
    url: '/api/accounting-code',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AccountingCode\CreateAccountingCodeController::__invoke
* @see app/Http/Controllers/AccountingCode/CreateAccountingCodeController.php
* @route '/api/accounting-code'
*/
CreateAccountingCodeController.url = (options?: RouteQueryOptions) => {
    return CreateAccountingCodeController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountingCode\CreateAccountingCodeController::__invoke
* @see app/Http/Controllers/AccountingCode/CreateAccountingCodeController.php
* @route '/api/accounting-code'
*/
CreateAccountingCodeController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateAccountingCodeController.url(options),
    method: 'post',
})

export default CreateAccountingCodeController